import { Link } from "react-router-dom";
import { buttonClass, EmptyState } from "@promptgatewaysadmin/ui";

export function NotFound() {
  return (
    <EmptyState
      title="We couldn't find that page"
      description="The link may be old, or the page may have moved. Nothing is wrong with your account."
      actions={
        <Link className={buttonClass("primary")} to="/">
          Go to Home
        </Link>
      }
    />
  );
}
